import * as types from './types';

const initialState = {
  collaborators: [],
  errorCollaborators: false,
  hasCollaboratorsInfo: false,
  loadingCollaborators: false,
  updatedUserResponsible: false,
  loadingUpdateUserResponsible: false,
  errorUpdatingUserResponsible: false,
  bulkSuccessful: 0,
  bulkError: 0
};

function ResponsibleUpdateReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_COLLABORATORS_INFO:
      return {
        ...state,
        errorCollaborators: false,
        loadingCollaborators: true
      };

    case types.FETCH_COLLABORATORS_INFO_COMPLETED:
      return {
        ...state,
        collaborators: action.payload,
        loadingCollaborators: false,
        hasCollaboratorsInfo: true
      };

    case types.FETCH_COLLABORATORS_INFO_FAILED:
      return {
        ...state,
        errorCollaborators: true,
        loadingCollaborators: false
      };

    case types.UPDATE_USER_RESPONSIBLE_BULK:
      return {
        ...state,
        loadingUpdateUserResponsible: true,
        updatedUserResponsible: false,
        errorUpdatingUserResponsible: false
      };

    case types.UPDATE_USER_RESPONSIBLE_BULK_COMPLETED:
      return {
        ...state,
        updatedUserResponsible: true,
        loadingUpdateUserResponsible: false,
        bulkSuccessful: action.payload.successfulPostings || 0,
        bulkError: action.payload.errorPostings || 0
      };

    case types.UPDATE_USER_RESPONSIBLE_BULK_FAILED:
      return {
        ...state,
        errorUpdatingUserResponsible: true,
        loadingUpdateUserResponsible: false,
        bulkError: action.meta.body.postingIds.length || 1
      };

    default:
      return state;
  }
}

export default ResponsibleUpdateReducer;
